export default "__VITE_ASSET__D5_EuN7O__"